import axios from "axios";
import { ApiUrl, header } from "../../utils/modules";

class AlertService {
  getAlertsBySupervisor(supervisorId, page, limit, dateJour = "") {
    return axios.get(`${ApiUrl}alerts/supervisor/${supervisorId}`, {
      headers: header("json").headers,
      params: {
        page,
        limit,
        ...(dateJour ? { dateJour } : {}),
      },
    });
  }

  getUnreadCount(supervisorId) {
    return axios.get(`${ApiUrl}alerts/unread-count/${supervisorId}`, {
      headers: header("json").headers,
    });
  }

  markAllAsRead(supervisorId) {
    return axios.patch(
      `${ApiUrl}alerts/read-all/${supervisorId}`,
      {},
      {
        headers: header("json").headers,
      }
    );
  }

  markOneAsRead(alertId) {
    return axios.patch(
      `${ApiUrl}alerts/read/${alertId}`,
      {},
      {
        headers: header("json").headers,
      }
    );
  }

  createTimeAlert(data) {
    return axios.post(`${ApiUrl}alerts/time-alert`, data, {
      headers: header("json").headers,
    });
  }

  deleteAlerts(ids) {
    return axios.delete(`${ApiUrl}alerts/delete-many`, {
      headers: header("json").headers,
      data: { ids },
    });
  }
}

export default new AlertService();